"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reduxForm = require("redux-form");
var _cssClassesHelper = require("../../helpers/cssClassesHelper");
var _Modal = _interopRequireDefault(require("../common/Modal/Modal"));
var _Button = require("../form/Button/Button");
var _modalDecorator = _interopRequireDefault(require("../../hocs/modalDecorator"));
var _modalActions = require("../../redux/actions/modalActions");
var _FormItem = require("../form/FormItem");
var _NumberInput = require("../form/NumberInput");
var _numberFormatter = require("../../helpers/numberFormatter");
var _formValidations = require("../../helpers/formValidations");
require("./FuturesClosePositionModal.css");
var _futuresPositionsActions = require("../../redux/futures/actions/futuresPositionsActions");
var _APLabelWithText = _interopRequireDefault(require("../common/APLabelWithText"));
var _Slider = require("../common/Slider/Slider");
var _productsSelectors = require("../../redux/selectors/productsSelectors");
var _decimalPlacesHelper = require("../../helpers/decimalPlaces/decimalPlacesHelper");
var _hooks = require("../OrderEntryComponents/hooks");
var _useEstimatedPnLValues = _interopRequireDefault(require("./useEstimatedPnLValues"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var bemClasses = (0, _cssClassesHelper.getBEMClasses)('futures-close-position-modal');
var FUTURES_CLOSE_POSITION_FORM = 'futuresClosePosition';
var formatMoney = function formatMoney(value, symbol) {
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, (0, _numberFormatter.formatNumberToLocale)(value, symbol), /*#__PURE__*/_react["default"].createElement("span", {
    className: bemClasses('label-currency')
  }, " ", symbol));
};
var FuturesClosePositionModal = function FuturesClosePositionModal(props) {
  var _position$instrument2, _position$instrument4, _position$instrument6;
  var isOpen = props.isOpen,
    close = props.close,
    handleSubmit = props.handleSubmit,
    position = props.position,
    mode = props.mode,
    isDisabled = props.invalid;
  var _useTranslation = (0, _reactI18next.useTranslation)('futures'),
    t = _useTranslation.t;
  var dispatch = (0, _reactRedux.useDispatch)();
  var _useState = (0, _react.useState)(0),
    _useState2 = _slicedToArray(_useState, 2),
    sliderValue = _useState2[0],
    setSliderValue = _useState2[1];
  var formValues = (0, _hooks.useFormValues)(FUTURES_CLOSE_POSITION_FORM);
  var _useEstimatedPnLValue = (0, _useEstimatedPnLValues["default"])(formValues, position, mode),
    estimatedPnLValue = _useEstimatedPnLValue.estimatedPnLValue;

  // Initialize form values when the modal opens. Amount is set to position size by default
  (0, _react.useEffect)(function () {
    if (isOpen && position !== null && position !== void 0 && position.PositionSize) {
      dispatch((0, _reduxForm.change)(FUTURES_CLOSE_POSITION_FORM, 'amount', position.PositionSize));
      setSliderValue(100);
    }
  }, [isOpen, position === null || position === void 0 ? void 0 : position.PositionSize, dispatch]);
  var quantityDp = (0, _react.useMemo)(function () {
    var _position$instrument;
    return (0, _decimalPlacesHelper.convertIncrementToIntDecimalPlaces)(position === null || position === void 0 || (_position$instrument = position.instrument) === null || _position$instrument === void 0 ? void 0 : _position$instrument.QuantityIncrement);
  }, [position === null || position === void 0 || (_position$instrument2 = position.instrument) === null || _position$instrument2 === void 0 ? void 0 : _position$instrument2.QuantityIncrement]);
  var decimalsMap = (0, _reactRedux.useSelector)(_productsSelectors.decimalsByProductId);
  var sliderPercentageIncrement = (0, _react.useMemo)(function () {
    var _position$instrument3;
    var sliderStepsAmount = (position === null || position === void 0 ? void 0 : position.PositionSize) / (position === null || position === void 0 || (_position$instrument3 = position.instrument) === null || _position$instrument3 === void 0 ? void 0 : _position$instrument3.QuantityIncrement);
    var stepSize = 100 / sliderStepsAmount;
    // Round to 2 decimal places to avoid floating point issues
    return parseFloat(stepSize.toFixed(2));
  }, [position === null || position === void 0 ? void 0 : position.PositionSize, position === null || position === void 0 || (_position$instrument4 = position.instrument) === null || _position$instrument4 === void 0 ? void 0 : _position$instrument4.QuantityIncrement]);
  var onSliderChange = (0, _react.useCallback)(function (value) {
    var _position$instrument5;
    var quantityIncrement = (position === null || position === void 0 || (_position$instrument5 = position.instrument) === null || _position$instrument5 === void 0 ? void 0 : _position$instrument5.QuantityIncrement) || 0.01;
    var sliderStepsAmount = position.PositionSize / quantityIncrement;
    var stepSize = 100 / sliderStepsAmount;

    // Snap to nearest valid step
    var nearestStep = Math.round(value / stepSize);
    var snappedValue = Math.min(nearestStep * stepSize, 100);
    setSliderValue(snappedValue);
    var rawAmount = position.PositionSize * snappedValue / 100;
    var amount = Math.round(rawAmount / quantityIncrement) * quantityIncrement;
    dispatch((0, _reduxForm.change)(FUTURES_CLOSE_POSITION_FORM, 'amount', amount));
  }, [dispatch, position]);
  var notGreaterThanPositionSize = (0, _react.useCallback)(function (value) {
    if (!position) return undefined;
    return value > position.PositionSize ? t('Amount cannot be greater than position size') : undefined;
  }, [position, t]);
  if (!isOpen || !position) return null;
  var positionDetails = [{
    label: "".concat(t('Pair'), ":"),
    text: (_position$instrument6 = position.instrument) === null || _position$instrument6 === void 0 ? void 0 : _position$instrument6.Symbol
  }, {
    label: "".concat(t('Position Type'), ":"),
    text: position.PositionType
  }, {
    label: "".concat(t('Entry Price'), ":"),
    text: formatMoney(position.EntryPrice, position.QuoteProductSymbol)
  }, {
    label: "".concat(t('Market Price'), ":"),
    text: formatMoney(position.MarkPrice, position.QuoteProductSymbol)
  }, {
    label: "".concat(t('Unrealized P&L'), ":"),
    text: formatMoney(position.UnrealizedProfitAndLoss, position.QuoteProductSymbol)
  }];
  var getDecimalPlacesForProduct = function getDecimalPlacesForProduct(productId) {
    return decimalsMap[productId] || 2;
  };
  var quoteProductDecimalPlaces = getDecimalPlacesForProduct(position.QuoteProductId);
  var handleClose = function handleClose() {
    dispatch((0, _reduxForm.reset)(FUTURES_CLOSE_POSITION_FORM));
    setSliderValue(0);
    close();
  };
  var onSubmit = function onSubmit(values) {
    if (mode === 'Market') {
      dispatch((0, _futuresPositionsActions.closeFuturesPositionByMarket)(position));
    } else {
      dispatch((0, _futuresPositionsActions.closeFuturesPositionByLimit)(position, values, mode));
    }
    handleClose();
  };
  var handleAmountChange = function handleAmountChange(e, newValue) {
    if (newValue !== undefined && newValue !== null && newValue >= 0 && position.PositionSize) {
      var percentage = Math.min(Math.max(parseFloat(newValue) / position.PositionSize * 100, 0), 100);
      setSliderValue(percentage);
    }
  };
  var title = mode === 'Limit' ? t('Limit Close') : t('Market Close');
  return /*#__PURE__*/_react["default"].createElement(_Modal["default"], {
    customClass: bemClasses('modal'),
    isOpen: isOpen,
    title: title,
    onCancel: handleClose,
    close: handleClose
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: bemClasses('position-details-table')
  }, positionDetails.map(function (item) {
    return /*#__PURE__*/_react["default"].createElement(_APLabelWithText["default"], {
      key: item.label,
      label: item.label,
      text: item.text,
      customClass: bemClasses()
    });
  })), /*#__PURE__*/_react["default"].createElement("form", {
    onSubmit: handleSubmit(onSubmit)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: bemClasses('form-group')
  }, mode === 'Limit' && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_FormItem.RFormInputItem, {
    component: _NumberInput.AmountInput,
    name: "closingPrice",
    size: "small",
    label: t('Closing Price'),
    infoText: /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, t('Estimated P&L'), ":", ' ', /*#__PURE__*/_react["default"].createElement("span", {
      className: bemClasses('estimated-pnl-value')
    }, estimatedPnLValue, " ", position.QuoteProductSymbol)),
    placeholder: "0",
    validate: [_formValidations.required, _formValidations.greaterThanZero],
    symbol: position.QuoteProductSymbol,
    decimalPlaces: quoteProductDecimalPlaces
  })), /*#__PURE__*/_react["default"].createElement(_FormItem.RFormInputItem, {
    component: _NumberInput.AmountInput,
    name: "amount",
    size: "small",
    label: t('Amount'),
    placeholder: "0",
    validate: [_formValidations.required, _formValidations.greaterThanZero, notGreaterThanPositionSize],
    symbol: position.BaseProductSymbol,
    decimalPlaces: quantityDp,
    onChange: handleAmountChange
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: bemClasses('slider-container')
  }, /*#__PURE__*/_react["default"].createElement(_Slider.Slider, {
    onChange: onSliderChange,
    value: sliderValue,
    breakpoints: [0, 100],
    step: sliderPercentageIncrement,
    formatOutput: function formatOutput(value) {
      return "".concat(Math.round(value), "%");
    },
    showBreakPoints: false
  }), (mode === 'Limit' && formValues.closingPrice > 0 && formValues.amount > 0 || mode === 'Market' && formValues.amount > 0) && /*#__PURE__*/_react["default"].createElement("div", {
    className: bemClasses('transaction-summary')
  }, t('transaction_summary', {
    baseSymbol: position.BaseProductSymbol,
    amount: (0, _numberFormatter.formatNumberToLocale)(formValues.amount, quantityDp),
    priceType: mode === 'Limit' ? t('price') : t('market price'),
    profit: estimatedPnLValue,
    quoteSymbol: position.QuoteProductSymbol,
    closingPrice: mode === 'Limit' ? (0, _numberFormatter.formatNumberToLocale)(formValues.closingPrice, quoteProductDecimalPlaces) : ''
  })))), mode === 'Limit' && /*#__PURE__*/_react["default"].createElement(_FormItem.RFormButtonToggle, {
    size: "xs",
    variant: "secondary",
    className: bemClasses('strategies-checkbox'),
    label: t('Post'),
    name: "post"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: bemClasses('buttons')
  }, /*#__PURE__*/_react["default"].createElement(_Button.Button, {
    disabled: isDisabled,
    variant: "primary",
    size: "md",
    type: "submit"
  }, t('Submit')))));
};
FuturesClosePositionModal.propTypes = {
  isOpen: _propTypes["default"].bool,
  close: _propTypes["default"].func,
  handleSubmit: _propTypes["default"].func.isRequired,
  position: _propTypes["default"].object,
  mode: _propTypes["default"].string.isRequired,
  notionalProduct: _propTypes["default"].shape({
    DecimalPlaces: _propTypes["default"].number.isRequired,
    Product: _propTypes["default"].string.isRequired
  }).isRequired,
  invalid: _propTypes["default"].bool.isRequired
};
FuturesClosePositionModal.defaultProps = {
  isOpen: false,
  close: function close() {},
  position: null
};
var _default = exports["default"] = (0, _reduxForm.reduxForm)({
  form: FUTURES_CLOSE_POSITION_FORM
})((0, _modalDecorator["default"])({
  name: _modalActions.MODAL_TYPES.FUTURES_CLOSE_POSITION
})(FuturesClosePositionModal));